import { Skeleton } from './Skeleton';

export interface SkeletonAvatarProps {
  /** Diameter of the avatar circle (default: '44px') */
  size?: string;
  /** Additional CSS class */
  className?: string;
}

export function SkeletonAvatar({ size = '44px', className }: SkeletonAvatarProps) {
  return (
    <div aria-hidden="true" className={className}>
      <Skeleton width={size} height={size} borderRadius="50%" />
    </div>
  );
}

export default SkeletonAvatar;
